import styled from "styled-components";

import StyledImage from "components/Image";

import theme from "config/theme";

export const Inner = styled.div`
  width: 50%;

  @media (max-width: ${theme.size.tablet}) {
    width: 100%;
    text-align: center;
  }
`;

export const Image = styled(StyledImage)`
  display: block;
  position: relative;
  width: calc(50% - 150px);
  margin: 0 0 0 auto;

  @media (max-width: ${theme.size.desktop}) {
    width: calc(50% - 70px);
  }
`;
